export default {
	app: {
		brand: 'HeySens'
	},
	topbar: {
		settings: '设置',
		language: '语言'
	},
	locale: {
		zh: '中文',
		vi: 'Tiếng Việt'
	},
	nav: {
		analytics: {
			group: '数据分析',
			total: '总计',
			chartStats: '图表统计',
			test: '测试'
		},
		enterprise: {
			group: '企业管理',
			config: '企业配置',
			notice: '发布通知'
		},
		events: {
			group: '事件管理',
			records: '事件记录',
			sensors: '传感设备管理'
		},
		shower: {
			group: '花洒管理',
			recordsStaff: '洗澡记录（人员）',
			recordsDevice: '洗澡记录（设备）',
			devices: '设备管理',
			staff: '人员管理'
		},
		admin: {
			group: '后台管理',
			safety: '安全员管理',
			logs: '日志管理'
		},
		help: {
			group: '帮助',
			docs: '文档'
		}
	},
	common: {
		actions: {
			confirm: '确认',
			cancel: '取消',
			save: '保存',
			search: '搜索',
			delete: '删除'
		},
		feedback: {
			error: '发生错误',
			success: '操作成功',
			failed: '操作失败'
		}
	},
	chartTable: {
		eventTypeStats: '事件类型统计',
		filters: {
			yesterday: '昨日',
			today: '今日',
			thisWeek: '本周',
			thisMonth: '本月'
		},
		trend: {
			totalCaptures: '趋势图（总抓拍数）',
			unsafeCount: '趋势图（违规数）'
		},
		range: {
			oneDay: '1天',
			sevenDays: '7天',
			thirtyDays: '30天'
		},
		messages: {
			maxRangeExceeded: '时间跨度不能超过一年'
		}
	},
	chartDemo: {
		datasetLabel: '振幅数据集',
		maxShow: '幅值',
		ultraDist: '测距(mm)',
		ultraCount: '采样点数',
		ultraCalc: '计算距离(mm)',
		draw: '绘制图形',
		linearChart: '线性图表'
	},
	landing: {
		nav: {
			home: '首页',
			platform: '平台',
			product: '产品',
			resources: '资源',
			about: '关于'
		},
		hero: {
			title: '<span class="font-light block">HeySens</span>让传感器说Hey',
			description: 'Sed blandit libero volutpat sed cras. Fames ac turpis egestas integer. Placerat in egestas erat...',
			getStarted: '开始使用'
		},
		features: {
			title: '非凡特性',
			subtitle: 'Placerat in egestas erat...',
			easyToUse: {
				title: '易于使用',
				desc: 'Posuere morbi leo urna molestie.'
			},
			freshDesign: {
				title: '全新设计',
				desc: 'Semper risus in hendrerit.'
			},
			wellDocumented: {
				title: '文档齐全',
				desc: 'Non arcu risus quis varius quam quisque.'
			},
			responsiveLayout: {
				title: '响应式布局',
				desc: 'Nulla malesuada pellentesque elit.'
			},
			cleanCode: {
				title: '代码整洁',
				desc: 'Condimentum lacinia quis vel eros.'
			},
			darkMode: {
				title: '暗黑模式',
				desc: 'Convallis tellus id interdum velit laoreet.'
			},
			readyToUse: {
				title: '开箱即用',
				desc: 'Mauris sit amet massa vitae.'
			},
			modernPractices: {
				title: '现代实践',
				desc: 'Elementum nibh tellus molestie nunc non.'
			},
			privacy: {
				title: '隐私保护',
				desc: 'Neque egestas congue quisque.'
			},
			testimonial: {
				name: 'Joséphine Miller',
				company: 'Peak Interactive',
				quote: '“Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.”'
			}
		},
		highlight: {
			title1: '无处不在的强大',
			subtitle1: 'Amet consectetur adipiscing elit...',
			feature1: {
				title: 'Congue Quisque Egestas',
				desc: 'Lectus arcu bibendum at varius vel pharetra vel turpis nunc. Eget aliquet nibh praesent tristique magna sit amet purus gravida. Sit amet mattis vulputate enim nulla aliquet.'
			},
			feature2: {
				title: 'Celerisque Eu Ultrices',
				desc: 'Adipiscing commodo elit at imperdiet dui. Viverra nibh cras pulvinar mattis nunc sed blandit libero. Suspendisse in est ante in. Mauris pharetra et ultrices neque ornare aenean euismod elementum nisi.'
			}
		},
		pricing: {
			title: '无与伦比的价格',
			subtitle: 'Amet consectetur adipiscing elit...',
			perMonth: '每月',
			free: {
				title: '免费版',
				btn: '开始使用'
			},
			startup: {
				title: '初创版',
				btn: '免费试用'
			},
			enterprise: {
				title: '企业版',
				btn: '获取报价'
			},
			features: {
				responsive: '响应式布局',
				pushMessages: '无限推送消息',
				support: '50个支持工单',
				shipping: '免运费'
			}
		},
		footer: {
			company: {
				title: '公司',
				aboutUs: '关于我们',
				news: '新闻',
				investorRelations: '投资者关系',
				careers: '招聘',
				mediaKit: '媒体包'
			},
			resources: {
				title: '资源',
				getStarted: '开始使用',
				learn: '学习',
				caseStudies: '案例研究'
			},
			community: {
				title: '社区',
				discord: 'Discord',
				events: '活动',
				faq: '常见问题',
				blog: '博客'
			},
			legal: {
				title: '法律',
				brandPolicy: '品牌政策',
				privacyPolicy: '隐私政策',
				termsOfService: '服务条款'
			}
		}
	},
	logManage: {
		title: '日志管理',
		rangePlaceholder: '选择时间范围',
		export: '导出',
		empty: '暂无日志数据。',
		loading: '日志数据加载中，请稍候。',
		exportingTitle: '正在导出',
		exportingMessage: '系统正在导出日志列表，请稍候',
		exportFileName: '操作日志',
		columns: {
			operationTime: '操作时间',
			userName: '姓名',
			operator: '操作人',
			action: '操作事项'
		}
	},
	dashboard: {
		summary: {
			last24Hours: '24小时最新事件',
			thisWeek: '本周事件统计',
			monthlyReviewed: '本月云分析事件总数',
			monthlyViolation: '本月违规事件总数'
		},
		actions: {
			more: '更多'
		},
		latestEvents: {
			title: '最新事件（Top 10）',
			firstAlarmImage: '首警图',
			type: '类型',
			time: '时间',
			details: '详细'
		},
		topN: {
			title: '本月未审核统计（Top 10）',
			region: '区域',
			field: '场地',
			enterprise: '企业',
			enterprisePrefix: '企业：{enterprise}',
			fieldCount: '场地数量：{count}',
			fieldPrefix: '场地：{enterprise}->{field}'
		},
		notifications: {
			title: '通知',
			system: '系统通知',
			enterprise: '企业通知',
			today: '今天',
			twoDays: '两天',
			oneWeek: '一周',
			todayTitle: '今天 {date}',
			yesterdayTitle: '昨天{date}',
			earlierTitle: '更早'
		},
		detail: {
			title: '事件详情',
			firstAlarmImage: '首警图',
			rule: '规则',
			testDescription: '测试功能描述',
			video: '视频',
			enterprise: '企业',
			field: '场地',
			region: '区域',
			point: '点位',
			cameraIp: '摄像头IP',
			violationEvent: '违规事件',
			riskLevel: '风险等级',
			levelTag: '{level} 级',
			captureTime: '拍摄时间',
			auditStatus: '审核状态',
			compliant: '合规',
			nonCompliant: '违规',
			unreviewed: '未审阅',
			auditRecords: '审核记录',
			original: '最开始'
		},
		messages: {
			requestError: '请求错误'
		}
	},
	eventRecords: {
		title: '查询事件记录',
		filters: {
			enterprise: '所属企业',
			field: '所属场地',
			region: '所属区域',
			camera: '所属摄像头',
			timeRange: '选择时间范围',
			status: '状态',
			eventType: '事件类型'
		},
		actions: {
			downloadWord: 'Word下载',
			downloadExcel: 'Excel下载',
			details: '详情',
			delete: '删除'
		},
		sort: {
			placeholder: '按时间排序',
			newestFirst: '时间从近到远',
			oldestFirst: '时间从远到近'
		},
		list: {
			field: '场地',
			region: '区域',
			camera: '摄像头',
			eventType: '事件类型',
			noRegion: '[无区域]'
		},
		status: {
			compliant: '合规',
			nonCompliant: '违规',
			unreviewed: '未审阅',
			deleted: '删',
			pendingAudit: '待审核',
			all: '全部',
			audited: '已审核'
		},
		detail: {
			title: '事件详情',
			firstAlarmImage: '首警图',
			rule: '规则',
			video: '视频',
			enterprise: '企业',
			field: '场地',
			region: '区域',
			point: '点位',
			cameraIp: '摄像头IP',
			captureTime: '拍摄时间',
			auditStatus: '审核状态',
			violationEvent: '违规事件',
			selectEventType: '选择事件类型',
			riskLevel: '风险等级',
			selectRiskLevel: '选择风险等级',
			levelTag: '{level}级',
			violationJudgment: '违规判别',
			compliantBtn: '合规',
			nonCompliantBtn: '违规',
			compliantPlaceholder: '可输入“合规”意见,也可默认为空',
			nonCompliantPlaceholder: '可输入“违规”意见,也可默认为空',
			auditRecords: '审核记录',
			original: '最开始',
			confirmDeleteRecord: '确定删除该条审核记录吗',
			continueReview: '继续审核',
			previous: '上一条',
			next: '下一条'
		},
		downloadDialog: {
			title: '下载文件中',
			message: '文件正在下载中，请不要关闭本窗口，也不要刷新页面'
		},
		messages: {
			requestError: '请求错误',
			operationFailed: '操作失败',
			confirmSuccess: '确认成功',
			parameterError: '参数错误',
			networkError: '发生网络错误',
			unknownFile: '未知文件',
			confirmCompliant: '确定合规吗?',
			confirmNonCompliant: '确定违规吗?'
		}
	},
	sensorManage: {
		title: '传感设备管理',
		addCamera: '新增摄像头',
		export: '导出',
		import: '导入',
		downloadTemplate: '下载模板',
		search: '查询',
		placeholders: {
			enterprise: '所属企业',
			field: '所属场地',
			region: '所属区域',
			cameraName: '摄像头名称'
		},
		table: {
			empty: '暂无传感器数据。',
			loading: '正在加载传感器数据，请稍候。',
			name: '摄像头名称',
			ip: 'IP',
			enterprise: '企业',
			field: '场地',
			region: '区域',
			account: '用户名',
			password: '密码',
			push: '推送',
			actions: '操作',
			edit: '编辑',
			delete: '删除'
		},
		dialogs: {
			add: '添加摄像头',
			edit: '编辑摄像头',
			cameraPosition: '摄像头位置',
			cameraName: '摄像头名称',
			videoUrl: '视频流地址',
			cameraIp: '摄像头Ip',
			account: '账号',
			password: '密码',
			judgeRule: '审核规则',
			exportingTitle: '正在导出',
			exportingMessage: '系统正在导出摄像头列表，请稍候',
			viewRule: '查看规则',
			editRule: '编辑规则',
			runTime: '运行时间',
			startTime: '开始时间',
			endTime: '结束时间',
			pushFeature: '推送功能',
			pushRule: '推送规则'
		},
		ruleHints: {
			withinMinutes: '分钟内，预警',
			stopAfterTimes: '次，停止预警推送',
			resumeAfterMinutes: '分钟后，继续推送'
		},
		validation: {
			cameraName: '请输入正确的姓名，由中文或者英文组成',
			videoUrl: '请输入正确的视频流地址',
			cameraIp: '请输入正确的IP地址',
			account: '请输入正确的账号信息',
			password: '请输入正确的密码'
		},
		confirmDelete: '确定要删除这个摄像头吗？',
		exportFileName: '摄像头管理',
		templateFileName: '摄像头倒入模版',
		pushLabels: {
			push: '推送',
			noPush: '不推送'
		},
		templateColumns: [
			'摄像头名称',
			'摄像头IP',
			'所属区域',
			'所属位置',
			'企业名称',
			'所属场地',
			'用户名',
			'密码',
			'视频流地址',
			'是否推送（0推送1不推送）'
		],
		importSuccess: '导入成功'
	},
	notifyManage: {
		title: '通知管理',
		publish: '发布',
		empty: '暂无通知数据。',
		loading: '通知数据加载中，请稍候。',
		columns: {
			content: '内容',
			type: '类型',
			publishedAt: '发布时间',
			actions: '操作'
		},
		types: {
			system: '系统',
			enterprise: '企业'
		},
		dialog: {
			title: '发布通知',
			rule: '规则',
			selectType: '选择类型',
			selectEnterprisePermission: '选择企业权限',
			content: '内容（限140个字符）'
		},
		messages: {
			selectType: '请选择通知类型',
			selectEnterprise: '请选择企业',
			confirmDelete: '确定要删除这条通知吗'
		}
	},
	notifyList: {
		empty: '没有新的通知记录',
		loading: '通知数据加载中，请稍候。',
		columns: {
			index: '序号',
			content: '内容',
			type: '类型',
			publishedAt: '发布时间'
		}
	},
	groupConfig: {
		searchPlaceholder: '关键词搜索',
		add: '新增',
		enterpriseName: '企业名称',
		managerAccount: '管理员账号',
		password: '密码',
		empty: '暂无企业数据。',
		loading: '企业数据加载中，请稍候。',
		columns: {
			enterprise: '企业',
			actions: '操作'
		},
		selectEnterpriseHint: '<< 单击左边企业，显示场地信息',
		validation: {
			enterpriseName: '请输入正确的企业名称，由中文、英文或者数字组成',
			managerAccount: '请输入正确的管理员账号',
			password: '请输入超过6位密码'
		},
		dialogs: {
			addEnterprise: '新增企业',
			editEnterprise: '编辑企业',
			addCluster: '新增集群',
			editCluster: '编辑集群'
		},
		messages: {
			requestError: '请求错误',
			selectParentEnterprise: '请选择父企业',
			confirmDeleteEnterprise: '确认删除企业吗？',
			confirmDeleteCluster: '确认删除集群吗？',
			operationSuccess: '操作“{name}”成功',
			deleteSuccess: '删除“{name}”成功'
		}
	},
	login: {
		welcome: 'Welcome to HeySens!',
		subtitle: 'Sign in to continue',
		username: '用户名',
		password: '密码',
		signIn: '登  录',
		submitError: '提交错误',
		icpRecord: '粤ICP备2022095255号-2',
		logoAlt: 'HeySens 标志'
	},
	documentPage: {
		title: '操作说明',
		placeholder: '整理中，稍后发布'
	},
	showerRecords: {
		titleByPerson: '洗澡记录（按人员查）',
		titleByDevice: '洗澡记录（按设备查）',
		filters: {
			enterprise: '所属企业',
			field: '所属场地',
			region: '所属区域',
			timeRange: '选择时间范围',
			sn: 'SN号'
		},
		actions: {
			query: '查询',
			excelDownload: 'Excel下载',
			hideUsers: '隐藏用户',
			showUsers: '显示用户'
		},
		header: {
			total: '总数: {count}',
			id: 'ID: {id}',
			name: '姓名: {name}',
			height: '身高: {height} cm',
			phone: '手机号: {phone}'
		},
		tabs: {
			all: '全部',
			violation: '违规',
			noShower: '未洗澡'
		},
		states: {
			empty: '没有洗澡记录',
			loading: '刷新中，请等待...',
			qualified: '合格',
			nonCompliant: '违规',
			anonymousUser: '匿名用户'
		},
		columns: {
			name: '姓名',
			height: '身高',
			count: '次数',
			record: '记录',
			time: '时间',
			location: '位置',
			deviceName: '花洒名称',
			compliance: '合规',
			totalDuration: '总时长',
			headDuration: '头部时长',
			validDuration: '有效时长',
			noPerson: '水下无人',
			noWater: '中间停水',
			shampoo: '洗发',
			bodyWash: '沐浴',
			waterTemp: '水温',
			signal: '信号',
			totalWater: '总用水量'
		},
		download: {
			title: '下载文件中',
			message: '文件正在下载中，请不要关闭本窗口，也不要刷新页面',
			confirmExcel: '确定要下载Excel报表吗?',
			reportName: '洗澡报告',
			tooManyRecords: '统计数目大于1000，暂不支持下载'
		},
		messages: {
			dataError: '数据错误',
			requestError: '请求错误',
			networkError: '网络错误'
		},
		units: {
			times: '次',
			liters: '升',
			minutes: '分',
			seconds: '秒'
		}
	},
	showerStaff: {
		title: '花洒员工管理',
		addStaff: '新增员工',
		generateNumber: '生成编号',
		filters: {
			enterprise: '所属企业',
			field: '所属场地',
			name: '姓名'
		},
		header: {
			total: '总数: {count}'
		},
		states: {
			empty: '没有员工记录',
			loading: '刷新中，请等待...'
		},
		columns: {
			name: '姓名',
			territory: '属地',
			height: '身高',
			phone: '手机号',
			actions: '操作'
		},
		dialog: {
			addTitle: '新增员工',
			territory: '属地',
			staffName: '员工姓名',
			height: '身高',
			phone: '手机号'
		},
		messages: {
			invalidPhone: '手机号不正确',
			unsupportedHeight: '不支持的身高',
			fillName: '请填写姓名',
			selectEnterprise: '请选择企业',
			selectField: '请选择场地',
			confirmDelete: '确定要删除这个用户吗？'
		},
		export: {
			push: '推送',
			noPush: '不推送',
			cameraName: '摄像头名称',
			cameraIp: '摄像头IP',
			videoUrl: '视频流地址',
			username: '用户名',
			password: '密码',
			field: '所属场地',
			region: '细分区域',
			pushStatus: '是否推送',
			enterpriseName: '企业名称',
			position: '所属位置',
			pushTemplateHint: '是否推送（0推送1不推送）',
			cameraManageFile: '摄像头管理',
			cameraImportTemplate: '摄像头导入模板'
		}
	},
	showerDevice: {
		title: '花洒设备管理',
		search: '查询',
		edit: '编辑',
		filters: {
			enterprise: '所属企业',
			field: '所属场地',
			region: '所属区域',
			onlineStatus: '在线情况',
			deployStatus: '部署情况',
			sn: 'SN号'
		},
		header: {
			total: '总数: {count}'
		},
		states: {
			empty: '没找到花洒设备，可以联系深圳极源数科购买',
			loading: '刷新中，请等待...',
			offline: '离线',
			online: '在线',
			high: '高',
			low: '低',
			all: '所有',
			notDeployed: '未部署',
			deployed: '已部署',
			wiredNetwork: '有线网络'
		},
		columns: {
			version: '版本号',
			deviceName: '花洒名称',
			location: '位置',
			online: '在线',
			lastHeartbeat: '最近心跳',
			shampoo: '洗发露',
			bodyWash: '沐浴液',
			roomTemp: '室温',
			waterFlowThreshold: '水流阈值',
			actions: '操作'
		},
		dialog: {
			editTitle: '编辑设备',
			deviceLocation: '设备位置',
			deviceName: '设备名称',
			basicParams: '普通参数',
			height: '顶喷高度(cm)',
			minWaterFlow: '最小水流量(L/分)',
			headDuration: '头部时长(秒)',
			validDuration: '有效时长(秒)',
			shampooCount: '洗发水次数',
			bodyWashCount: '沐浴露次数',
			advancedParams: '高级参数',
			networkType: '外网网络',
			doorControlType: '门禁类型',
			detectionLevel: '检测级别',
			customized: '定制',
			customizedProgram: '定制程序',
			userParams: '用户参数',
			enableAnonymous: '使能匿名模式（开水就洗）',
			enableEasy: '使能Easy模式',
			validTimeEasy: '有效时间超过就开启Easy（秒）',
			totalTimeEasy: '总时间超过就开启Easy（秒）',
			anonymousHeight: '匿名身高(cm)',
			showerType: '洗澡类型',
			bubbleParams: '泡沫机参数',
			enableBubble: '使能泡沫机',
			bubbleUsageCount: '泡沫使用次数',
			startTimer: '开始计时时间（秒）',
			bubbleDuration: '泡沫时长（秒）',
			bubbleBeforeRinseTime: '泡沫前冲淋时间（秒）',
			bubbleAfterRinseTime: '泡沫后冲淋时间（秒）',
			bubbleAfterScrubTime: '泡沫后搓洗时间（秒）',
			algorithmType: '算法类型',
			note: '备注'
		},
		messages: {
			invalidHeight: '花洒高度不正确',
			invalidHeadDuration: '头部时长不正确',
			invalidValidDuration: '有效时长不正确',
			invalidBodyWashDuration: '沐浴露时长不正确',
			invalidShampooDuration: '洗发露时长不正确',
			invalidBubbleBeforeRinseTime: '泡沫前冲淋时间不正确',
			invalidBubbleAfterRinseTime: '泡沫后冲淋时间不正确',
			invalidBubbleAfterScrubTime: '泡沫后搓洗时间不正确',
			invalidWaterFlow: '水流量阈值不正确',
			unsupportedHeight: '不支持的花洒高度',
			unsupportedWaterFlow: '不支持的水流量'
		},
		units: {
			litersPerMinute: '升/分'
		}
	},
	saferManage: {
		title: '安全员管理',
		add: '新增',
		searchPlaceholder: '关键字查询',
		empty: '暂无安全员数据。',
		loading: '安全员数据加载中，请稍候。',
		columns: {
			name: '姓名',
			phone: '联系电话',
			type: '类型',
			status: '状态',
			actions: '操作'
		},
		types: {
			enterpriseUser: '企业用户',
			safer: '安全员'
		},
		dialog: {
			role: '角色',
			selectUserType: '选择用户类型',
			selectEnterprisePermission: '选择企业权限',
			name: '姓名',
			phone: '电话',
			password: '密码'
		},
		validation: {
			name: '请输入正确的姓名，由中文或者英文组成',
			phone: '请输入正确的电话',
			password: '请输入超过6位密码'
		},
		messages: {
			confirmDelete: '确定要删除这个安全员吗'
		}
	},
	reportDownload: {
		title: '报告下载',
		timeRange: '选择时间范围',
		export: '导出',
		empty: '暂无报告数据。',
		loading: '报告数据加载中，请稍候。',
		columns: {
			reportTime: '报告时间',
			reporter: '报告人',
			summary: '内容摘要',
			download: '下载'
		},
		exportingTitle: '正在导出',
		exportingMessage: '系统正在导出日志列表，请稍候',
		exportFileName: '操作日志'
	},
	roleManage: {
		title: '角色管理',
		searchPlaceholder: '人员编号',
		roleName: '角色名称',
		permission: '权限',
		status: '状态',
		confirmDelete: '确定要删除这个岗位吗？',
		addTitle: '新增角色',
		editTitle: '编辑角色',
		validation: {
			roleName: '请输入正确的角色名称，由中文、英文或者数字组成'
		}
	},
	employeeManage: {
		searchTitle: '查询员工',
		addEmployee: '新增员工',
		empty: '暂无数据。',
		loading: '数据加载中，请稍候。',
		id: 'ID',
		post: '所属岗位',
		name: '姓名',
		phone: '电话',
		contactPhone: '联系电话',
		password: '密码',
		status: '状态',
		routePermission: '路由权限',
		dataPermission: '数据权限',
		addTitle: '新增员工',
		editTitle: '编辑员工',
		confirmDelete: '确定要删除这个员工吗？',
		validation: {
			name: '请输入正确的姓名，由中文或者英文组成',
			phone: '请输入正确的电话',
			password: '请输入超过6位密码'
		}
	},
	fieldConfig: {
		addField: '新增场地',
		searchPlaceholder: '关键词搜索',
		dialogs: {
			addField: '新增场地',
			editField: '编辑场地',
			enterprise: '所属企业',
			fieldClass: '场地分区',
			fieldName: '场地名称',
			contact: '联系人',
			contactNumber: '联系方式',
			location: '位置',
			locate: '定位',
			regionManage: '区域管理',
			addRegion: '新增区域',
			editRegion: '编辑区域',
			regionName: '区域名称',
			positionManage: '位置管理',
			addPosition: '新增位置',
			editPosition: '编辑位置',
			parentRegion: '所属区域',
			positionName: '位置名称'
		},
		validation: {
			fieldClass: '请输入正确的场地分区，由中文、英文或者数字组成',
			fieldName: '请输入正确的场地名称，由中文、英文或者数字组成',
			contact: '请输入正确的联系人，由中文、英文或者数字组成',
			contactNumber: '请输入正确的手机号码',
			regionName: '请输入正确的区域名称，由中文、英文或者数字组成',
			positionName: '请输入正确的位置名称，由中文、英文或者数字组成'
		},
		states: {
			empty: '暂无数据。',
			loading: '数据加载中，请稍候。'
		},
		columns: {
			fieldName: '场地名称',
			contact: '联系人',
			contactNumber: '联系方式',
			actions: '操作',
			id: 'ID',
			regionName: '区域名称',
			belongField: '所属场地',
			positionName: '位置名称'
		},
		actions: {
			region: '区域',
			edit: '编辑',
			delete: '删除'
		},
		messages: {
			confirmDeleteField: '确定要删除这个场地吗？',
			confirmDeleteRegion: '确定要删除这个区域吗？',
			confirmDeletePosition: '确定要删除这个位置吗？',
			productSelected: '已选择项目',
			productUnselected: '已取消选择项目',
			fileUploaded: '文件已上传'
		}
	},
	clusterConfig: {
		viewFields: '查看场地',
		searchPlaceholder: '关键词搜索',
		empty: '暂无数据。',
		loading: '数据加载中，请稍候。',
		columns: {
			clusterName: '集群名称',
			contact: '联系人',
			contactNumber: '联系方式',
			actions: '操作'
		},
		actions: {
			field: '场地',
			edit: '编辑',
			delete: '删除'
		},
		dialog: {
			enterpriseName: '企业名称',
			managerAccount: '管理员账号',
			password: '密码',
			addTitle: '新增集群',
			editTitle: '编辑集群'
		},
		validation: {
			enterpriseName: '请输入正确的企业名称，由中文、英文或者数字组成',
			managerAccount: '请输入正确的管理员账号',
			password: '请输入超过6位密码'
		},
		messages: {
			selectParentEnterprise: '请选择父企业',
			confirmDelete: '确认刪除集群吗？'
		}
	},
	areaConfig: {
		back: '返回',
		addRegion: '新增区域',
		searchPlaceholder: '关键词搜索',
		dialogTitle: '新增区域',
		enterprise: '所属企业',
		regionName: '区域名称',
		invalidAccount: '无效账号',
		empty: '暂无数据。',
		loading: '数据加载中，请稍候。',
		columns: {
			regionName: '区域名称',
			fieldName: '所属场地',
			settings: '设置',
			actions: '操作'
		},
		actions: {
			edit: '编辑',
			delete: '删除'
		}
	}
};
